import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ShortenJobIdPipe } from '../../pipes';
import { UiModule } from './ui.module';
import {
  AuthenticationService,
  SnackbarService,
  ProcessorService,
  AuthInterceptor,
  TermsAndConditionsService,
  DialogService,
  JobsService,
  AuthGuard,
  JobGuard,
  RejectionsService, QuoteService
} from '../../services';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { JobUploaderService } from '../../services/standard/job-uploader.service';

@NgModule({
  imports: [
    CommonModule,
    UiModule,
    DropzoneModule,
    FormsModule,
    RouterModule,
    HttpClientModule,
    ReactiveFormsModule
  ],
  declarations: [
    ShortenJobIdPipe
  ],
  exports: [
    UiModule,
    FormsModule,
    HttpClientModule,
    DropzoneModule,
    RouterModule,
    ShortenJobIdPipe,
    CommonModule,
    ReactiveFormsModule
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        AuthGuard,
        JobGuard,
        AuthenticationService,
        SnackbarService,
        ProcessorService,
        TermsAndConditionsService,
        JobsService,
        JobUploaderService,
        DialogService,
        RejectionsService,
        QuoteService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthInterceptor,
          multi: true
        }
      ]
    };
  }
}
